import React, { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import BugFeatureStatistics from './BugFeatureStatistics';
import TodoBugFeatureList from './TodoBugFeatureList';
import InProgressBugFeatureList from './InProgressBugFeatureList';
import ClosedBugFeatureList from './ClosedBugFeatureList';
import DisplayBugFeature from './DisplayBugFeature';
import './styles.css';

const { TabPane } = Tabs;

export default function BugFeatureReports() {
  const [selectedBugFeature, setSelectedBugFeature] = useState({});

  const onSelectBugFeature = useCallback(
    bugFeature => () => {
      setSelectedBugFeature(bugFeature);
    },
    [selectedBugFeature],
  );

  const onRemoveBugFeature = () => {
    setSelectedBugFeature({});
  };

  return (
    <div>
      <BugFeatureStatistics />
      <div style={{ marginTop: '20px' }}>
        <Tabs>
          <TabPane key="todo" tab="To-Do">
            <TodoBugFeatureList onSelect={onSelectBugFeature} />
          </TabPane>
          <TabPane key="in-progress" tab="In-Progress">
            <InProgressBugFeatureList onSelect={onSelectBugFeature} />
          </TabPane>
          <TabPane key="closed" tab="Closed">
            <ClosedBugFeatureList onSelect={onSelectBugFeature} />
          </TabPane>
        </Tabs>
      </div>
      <DisplayBugFeature
        bugFeature={selectedBugFeature}
        onClose={onRemoveBugFeature}
      />
    </div>
  );
}
